// extracted by mini-css-extract-plugin
module.exports = {"preview":"_preview__fc5Gi","btns":"_btns__4_vTi","root":"_root__inWPh","actions":"_actions__r9vQT","next":"_next__0ojtC","loading":"_loading__t77Y2"};